import Contract from '../../models/contract';
import { ContractFinancialCap } from '../../models/contractFinancialCap';
import { authenticatedApi } from '../api';

/**
 * API pour la gestion des contrats
 */
export const contractApi = {
  /**
   * Récupère un contrat par son ID
   */
  async getById(contractId: number): Promise<Contract> {
    const response = await authenticatedApi.get(`/contract/${contractId}`);
    return response.data;
  },

  /**
   * Récupère les contrats d'un bénéficiaire
   */
  async getByBeneficiaryId(beneficiaryId: number): Promise<Contract[]> {
    const response = await authenticatedApi.get(`/contracts/beneficiary/${beneficiaryId}`);
    return response.data;
  },

  /**
   * Récupère les contrats d'un partenaire
   */
  async getByPartnerId(partnerId: number): Promise<Contract[]> {
    const response = await authenticatedApi.get(`/contracts/partner/${partnerId}`);
    return response.data;
  },

  /**
   * Récupère l'utilisation du plafond financier d'un contrat
   * Retourne les montants utilisés et disponibles (en centimes)
   */
  async getFinancialCapUsage(contractId: number): Promise<ContractFinancialCap> {
    const response = await authenticatedApi.get(`/contracts/${contractId}/financial-cap`);
    return response.data;
  },
};